import type { Project } from 'lib/project'

const getTokenId = ({
  ref,
}: Project.GenericRef<Project.DynamicValue>): string => `#${ref}#`

export default getTokenId
